<template>
  <main class="detail">
    <!-- Hero -->
    <section class="hero" aria-labelledby="page-title">
      <div class="section__inner hero__inner">
        <h2 id="page-title">주요행사</h2>
      </div>
    </section>

    <!-- 상단 제목/브레드크럼 -->
    <div class="section__inner">
      <nav class="crumbs" aria-label="breadcrumb">
        <ol>
          <li><a href="/newsmain">주요소식</a></li>
          <li aria-current="page">상세</li>
        </ol>
      </nav>

      <header class="detail-header">
        <h1 class="detail-title">{{ state.title }}</h1>
        <!-- <p class="detail-sub">2025-10-13 게시 · 공개</p> -->
      </header>

      <!-- 메타 블록 -->
      <section class="meta" aria-label="게시 정보">
        <dl class="meta-grid">
          <div>
            <dt>작성일</dt>
            <dd>{{ state.updatedAt ? state.updatedAt.slice(0, 10) : '-' }}</dd>
          </div>
          <!-- <div>
            <dt>공개여부</dt><dd>공개</dd>
          </div> -->
          <!-- <div>
                        <dt>접수기간</dt>
                        <dd>2025-10-13 ~ 2025-10-20</dd>
                    </div> -->
          <div>
            <dt>조회수</dt>
            <dd>{{ state.viewCount }}</dd>
          </div>
        </dl>
      </section>

      <!-- 본문 -->
      <article class="content1" aria-label="본문">
        <h2 class="sr-only">본문</h2>

        <!-- 본문 하단 이미지 나열 -->
        <div class="content-images" v-if="existingImgFiles.length">
          <figure v-for="(img, i) in existingImgFiles" :key="`content-img-${i}-${img.name}`" class="content-image">
            <img :src="apiBaseUrl + img.name" :alt="fileNameOnly(img.name)" loading="lazy"
              @error="($event) => $event.target.style.display = 'none'" />
          </figure>
        </div>

        <!-- 본문 텍스트 -->
        <!-- <p v-if="state.content" class="answer-text">
                {{ state.content }}
            </p> -->
        <div v-if="state.content" class="answer-text" v-html="state.content"></div>
      </article>

      <!-- 첨부파일 -->
      <section class="attachment" aria-labelledby="att-title" v-if="existingFiles.length">
        <h2 id="att-title" class="section-title">첨부파일</h2>

        <ul class="file-list">
          <li class="file" v-for="(f, i) in existingFiles" :key="`file-${i}-${f.name}`">
            <i class="fa-regular fa-file-lines" aria-hidden="true"></i>
            <span class="file-name" :title="fileNameOnly(f.name)">
              {{ fileNameOnly(f.name) }}
            </span>
            <!-- 파일 크기는 백엔드에서 제공 시에만 노출 (없으면 숨김) -->
            <!-- <span class="file-size">{{ f.sizeText }}</span> -->
            <button class="btn-link" @click="downloadFile(f.name)">다운로드</button>
          </li>
        </ul>
      </section>


      <!-- 이미지 갤러리 -->
      <!-- <section class="gallery" aria-labelledby="img-title" v-if="existingImgFiles.length">
            <h2 id="img-title" class="section-title">이미지</h2>

            <ul class="gallery-grid">
                <li v-for="(img, i) in existingImgFiles" :key="`img-${i}-${img.name}`">
               
                <img :src="apiBaseUrl + img.name" :alt="fileNameOnly(img.name)" />

                
                <div class="gallery-actions">
                    <button class="btn-link" @click="downloadImgFile(img.name)">다운로드</button>
                </div>
                </li>
            </ul>
            </section> -->


      <!-- 하단 네비게이션 -->
      <!-- <nav class="post-nav" aria-label="이전 다음 글">
                <a class="post-nav__item prev" href="#"><span>이전글</span><strong>9월 내부통제 워크숍 안내</strong></a>
                <a class="post-nav__item next" href="#"><span>다음글</span><strong>11월 온라인 세미나 공지</strong></a>
            </nav> -->

      <!-- 액션 바 (목록/인쇄) -->
      <div class="actionbar">
        <!-- <a href="/noticeList" class="btn-primary" aria-label="목록으로 이동">목록으로</a> -->
        <button class="btn-primary" @click="handleCancel">목록으로</button>
      </div>
    </div>
  </main>
</template>


<script setup>
import { ref, reactive, onMounted, watch } from 'vue'
// import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { updateViewCount, getNoticeDetail } from '@/api/notice'
import axios from 'axios';
// const checkUserId = computed(() => store.state.temp.userInfo)
const router = useRouter()
const route = useRoute()
// const store = useStore()
// 주요행사 초기값 설정 (작성일은 기본적으로 오늘 날짜)
const state = reactive({
  title: '',
  content: '',
  pinned: false,
  viewCount: 0
})


const existingFiles = ref([])     // 서버 파일 이름


const existingImgFiles = ref([])     // 이미지서버 파일 이름

const handleCancel = () => {
  router.back()
}

const VIEW_TTL_MS = 15 * 60 * 1000 // 15분

function getKey(noticeId) {
  return `notice-viewed-${noticeId}`
}
function shouldIncreaseView(noticeId) {
  const last = Number(localStorage.getItem(getKey(noticeId)) || 0)
  return Date.now() - last >= VIEW_TTL_MS
}
function markViewed(noticeId) {
  localStorage.setItem(getKey(noticeId), String(Date.now()))
}

async function loadDetailAndMaybeIncrement(noticeId) {
  if (!noticeId) return

  // 1) 조회수 증가 (15분 TTL)
  try {
    if (shouldIncreaseView(noticeId)) {
      await updateViewCount({ noticeId })
      // 낙관적 증가 (곧 상세 조회로 다시 덮어씌워짐)
      if (state.viewCount != null) state.viewCount += 1
      markViewed(noticeId)
    }
  } catch (e) {
    console.warn('뷰 카운트 업데이트 실패:', e)
  }

  // 2) 상세 조회
  const result = await getNoticeDetail({ noticeId })
  if (result?.result === 'ok') {
    state.noticeId = result.data.noticeId
    state.title = result.data.title
    state.content = result.data.content
    state.createdAt = result.data.createdAt
    state.updatedAt = result.data.updatedAt
    state.adminName = result.data.adminName
    state.pinned = result.data.pinned
    state.viewCount = result.data.viewCount

    const fileFields = [
      result.data.noticeFile1, result.data.noticeFile2, result.data.noticeFile3,
      result.data.noticeFile4, result.data.noticeFile5, result.data.noticeFile6,
      result.data.noticeFile7,
    ]
    existingFiles.value = fileFields.filter(Boolean).map(name => ({ name }))

    const imgFileFields = [
      result.data.noticeImgFile1, result.data.noticeImgFile2, result.data.noticeImgFile3,
    ]
    existingImgFiles.value = imgFileFields.filter(Boolean).map(name => ({ name }))
  }
}


onMounted(async () => {
  const noticeId = route.query?.noticeId
  loadDetailAndMaybeIncrement(noticeId)
})

watch(() => route.query.noticeId, (newId, oldId) => {
  if (newId && newId !== oldId) loadDetailAndMaybeIncrement(newId)
})

const apiBaseUrl = process.env.VUE_APP_API_URL; // 환경변수에서 API URL 가져오기

const downloadFile = async (filePath) => {
  try {
    // filePath가 절대 URL이라면 호스트/포트를 제거해 상대 경로만 추출
    // 예: http://localhost:8020/up_imgs/...  →  /up_imgs/...
    const relativePath = filePath.replace(/^https?:\/\/[^/]+/, '')

    // apiBaseUrl + 상대 경로를 합쳐 백엔드에서 직접 다운로드
    const downloadUrl = `${apiBaseUrl}${relativePath}`

    console.log('다운로드 요청 URL:', downloadUrl)

    const response = await axios({
      url: downloadUrl,
      method: 'GET',
      responseType: 'blob'
    })

    const blob = new Blob([response.data])
    const url = window.URL.createObjectURL(blob)

    // 파일명만 추출
    const fileName = fileNameOnly(relativePath)

    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()

    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('파일 다운로드 실패:', error)
    alert('파일 다운로드 중 문제가 발생했습니다.')
  }
}

// const downloadImgFile = async (filePath) => {
//   try {
//     // filePath가 절대 URL이라면 호스트/포트를 제거해 상대 경로만 추출
//     // 예: http://localhost:8020/up_imgs/...  →  /up_imgs/...
//     const relativePath = filePath.replace(/^https?:\/\/[^/]+/, '')

//     // apiBaseUrl + 상대 경로를 합쳐 백엔드에서 직접 다운로드
//     const downloadUrl = `${apiBaseUrl}${relativePath}`

//     console.log('다운로드 요청 URL:', downloadUrl)

//     const response = await axios({
//       url: downloadUrl,
//       method: 'GET',
//       responseType: 'blob'
//     })

//     const blob = new Blob([response.data])
//     const url = window.URL.createObjectURL(blob)

//     // 파일명만 추출
//     const fileName = fileNameOnly(relativePath)

//     const link = document.createElement('a')
//     link.href = url
//     link.setAttribute('download', fileName)
//     document.body.appendChild(link)
//     link.click()

//     document.body.removeChild(link)
//     window.URL.revokeObjectURL(url)
//   } catch (error) {
//     console.error('파일 다운로드 실패:', error)
//     alert('파일 다운로드 중 문제가 발생했습니다.')
//   }
// }

const fileNameOnly = (fullPath) => {
  if (!fullPath) return ''
  return fullPath.split('/').pop()
}
</script>

<style scoped>
.detail {
  font-family: 'Noto Sans KR', sans-serif;
  color: #0f172a;
}

/* 공통 레이아웃 */
.section__inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 16px;
  display: grid;
}

/* Hero */
.hero {
  background:
    linear-gradient(rgba(13, 6, 20, .6), rgba(13, 6, 20, .6)),
    url('/src/assets/news-main.jpeg') center 42% / 70% no-repeat;
  color: #fff;
}
.hero__inner {
  padding: 120px 16px;
  text-align: center;
}
.hero h2 {
  font-size: 1.625rem;
  font-weight: 700;
}
@media (max-width: 600px) {
  .hero__inner { padding: 60px 16px; }
}

/* 브레드크럼 */
.crumbs ol {
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 16px 0 6px;
  font-size: 0.95rem;
  color: #64748b;
}
.crumbs a {
  color: #64748b;
  text-decoration: underline;
}
.crumbs li + li::before {
  content: "/";
  margin-right: 8px;
}

/* 제목 */
.detail-header {
  padding: 10px 0 14px;
  border-bottom: 1px solid #e5e7eb;
}
.detail-title {
  margin: 0;
  font-size: 1.625rem;
  font-weight: 700;
}
.detail-sub {
  margin-top: 8px;
  color: #64748b;
}
p {
  font-size: 0.95rem;
}

/* 메타 */
.meta {
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  margin: 18px 0 22px;
}
.meta-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px 18px;
}
.meta-grid dt {
  font-weight: 700;
  font-size: 0.95rem;
}
.meta-grid dd {
  margin: 2px 0 0;
}
@media (max-width: 900px) {
  .meta-grid { grid-template-columns: repeat(2, 1fr); }
}

/* 본문 박스 */
.content1 {
  display: grid;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, .06);
  padding: 40px 24px;
  gap: 16px;
}

/* 이미지 */
.content-images {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}
.content-image img {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

/* ===== 핵심: v-html 대응 ===== */
.answer-text {
  line-height: 1.7;
}

/* p */
.answer-text :deep(p) {
  font-size: 0.95rem;
  margin-bottom: 1rem;
  line-height: 1.8;
}

/* img */
.answer-text :deep(img) {
  max-width: 100%;
  height: auto;
  margin: 10px 0;
}

/* 리스트 */
.answer-text :deep(ul),
.answer-text :deep(ol) {
  padding-left: 1.25rem;
  margin-bottom: 1rem;
}
.answer-text :deep(li) {
  font-size: 0.95rem;
  margin-bottom: 0.4rem;
}

/* 링크 */
.answer-text :deep(a) {
  color: #1d2088;
  text-decoration: underline;
}

/* 테이블 */
.answer-text :deep(table) {
  width: 100%;
  border-collapse: collapse;
  margin: 12px 0;
}
.answer-text :deep(th),
.answer-text :deep(td) {
  border: 1px solid #e5e7eb;
  padding: 8px;
  font-size: 0.95rem;
}

/* 첨부파일 */
.file-list {
  display: grid;
  gap: 8px;
}
.file {
  display: grid;
  grid-template-columns: 24px 1fr auto;
  align-items: center;
  gap: 10px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
}
.btn-link {
  background: none;
  border: none;
  color: #1d2088;
  font-weight: 700;
  cursor: pointer;
}

/* 버튼 */
.actionbar {
  display: grid;
  justify-content: end;
  margin-top: 20px;
}
.btn-primary {
  padding: 10px 16px;
  background: #1d2088;
  color: #fff;
  border-radius: 10px;
  font-weight: 700;
}

/* 접근성 */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
</style>
